import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, PropSync, Watch } from "vue-property-decorator";
import StringUtils from "@/utils/stringUtils";
import { format, setISODay } from "date-fns";
let ProgrammingBoard = class ProgrammingBoard extends Vue {
    emitCopy() {
    }
    emitUpdateContent() {
    }
    onUpdateContentValue() {
        // console.log(`${val} / ${oldVal}`)
        this.emitUpdateContent();
    }
    get textareaId() {
        return `programming-board-${this.board.level}-content`;
    }
    get daysOffFormated() {
        if (StringUtils.isBlank(this.board.days_off)) {
            return 'none';
        }
        let date = new Date();
        return this.board.days_off
            .split(',')
            .map(it => Number(it))
            .filter(it => Number.isInteger(it))
            .sort()
            .map(it => {
            date = setISODay(date, Number(it));
            return format(date, 'dddd');
        }).join(', ').toLowerCase();
    }
};
__decorate([
    Prop({ required: true })
], ProgrammingBoard.prototype, "board", void 0);
__decorate([
    Prop({ required: true })
], ProgrammingBoard.prototype, "previousBoard", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ProgrammingBoard.prototype, "disabled", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ProgrammingBoard.prototype, "copyDisabled", void 0);
__decorate([
    PropSync('content', { type: String, required: true })
], ProgrammingBoard.prototype, "contentValue", void 0);
__decorate([
    Emit('copy')
], ProgrammingBoard.prototype, "emitCopy", null);
__decorate([
    Emit('updateContent')
], ProgrammingBoard.prototype, "emitUpdateContent", null);
__decorate([
    Watch('contentValue')
], ProgrammingBoard.prototype, "onUpdateContentValue", null);
ProgrammingBoard = __decorate([
    Component({})
], ProgrammingBoard);
export default ProgrammingBoard;
